// Servicios.js
import React from 'react';
import suministrosImg from '../assets/suministros.png';
import obrasImg from '../assets/obras.png';
import vialidadImg from '../assets/vialidad.png';
import electricidadImg from '../assets/electricidad.png';
import materialesImg from '../assets/materiales.png';
import equiposImg from '../assets/equipos.png';

const servicios = [
  {
    titulo: 'Suministros, Servicios y Alquiler',
    imagen: suministrosImg,
    items: [
      'Suministros de uniformes industriales y bragas petroleras',
      'Suministros de uniformes corporativos, comerciales y profesionales',
      'Suministro de equipo de higiene y seguridad personal',
      'Suministro de papelería y artículos de oficina',
      'Suministros de materiales de ferretería y construcción',
      'Suministros de pinturas (industriales, marítimas, comerciales y de vialidad)',
      'Suministro y accesorios de equipos de fotocopiadora y computación',
      'Suministros y accesorios de equipos médicos, quirúrgicos y odontológicos',
      'Suministros y accesorios de equipos deportivos y de recreación',
      'Servicio de traslados de personas',
      'Servicio de transporte de equipos industriales',
      'Servicio de transporte de mercancía comercial',
      'Servicio de consultoría y recursos humanos',
      'Alquiler de equipos médicos y odontológicos',
      'Alquiler de vehículos: camiones, camionetas, buses, vans, ambulancias',
      'Alquiler de tráiler y plantas de tratamiento de aguas residuales',
      'Alquiler de maquinarias livianas y pesadas'
    ]
  },
  {
    titulo: 'Servicios de Obras Civiles',
    imagen: obrasImg,
    items: [
      'Cálculos de proyectos civiles, mecánicos y sanitarios',
      'Topografía y planos de ingeniería',
      'Movimiento de tierras, excavaciones, carga y compactación',
      'Fundaciones, estructuras metálicas, vaciado de concreto',
      'Revestimientos, trabajos en altura, instalación de sistemas',
      'Transporte y tratamiento de aguas servidas y desechos petroleros'
    ]
  },
  {
    titulo: 'Vialidad',
    imagen: vialidadImg,
    items: [
      'Escarificación y análisis de suelos',
      'Colocación y compactación de asfalto',
      'Construcción de aceras y brocales',
      'Instalación de bases para postes',
      'Limpieza de drenajes con Vacum',
      'Demarcación y señalización vial'
    ]
  },
  {
    titulo: 'Servicios Eléctricos',
    imagen: electricidadImg,
    items: [
      'Diseño e instalación de redes en media y baja tensión',
      'Transformadores, seccionadores, descargadores, luminarias',
      'Canalizaciones, tableros, plantas eléctricas y transferencias',
      'Mantenimiento de equipos eléctricos',
      'Estudios de calidad, análisis de fallas y pruebas técnicas'
    ]
  },
  {
    titulo: 'Suministros Eléctricos',
    imagen: materialesImg,
    items: [
      'Transformadores, postes, luminarias y herrajes',
      'Cables de diferentes calibres y tipos',
      'Plantas eléctricas y transferencias automáticas',
      'Fusibles y tableros eléctricos personalizados',
      'Capacitación técnica en mantenimiento de redes'
    ]
  },
  {
    titulo: 'Listado de Equipos',
    imagen: equiposImg,
    items: [
      'Trailer para Caseta policiales',
      'Plantas de Tratamientos de Aguas Negras',
      'Montacargas 12 Toneladas',
      'Jumbo Komatsu 220PC',
      'Retroexcavadora Jhon Deere 310',
      'Camión Mercedes Benz 711 con plataforma',
      'Compresor de aire con martillo',
      'Máquinas de soldar',
      'Camioneta pickup',
      'Vans de pasajeros',
      'Gandola con batea y/o lowboy',
      'Escarificadora de asfalto',
      'Equipo de colocación de asfalto (finisher, compactador, tampo)',
      'Vacum 160 Barriles',
      'Volquetas 22 m3',
      'Equipo camión Grúa 5 Toneladas',
      'Camión Cesta Aislado certificado por CORPOELEC 25/05/2023',
      'Camión de soldadura',
      'Cámara termografía',
      'Varilla telescópica, mano mecánica',
      'Motosierra, machete, pala draga, barretón',
      'Flejadora, Tijera nicopred, Tijera Yeperadora, cizalla',
      'Rompe Carga',
      'Caja de herramientas de Electricidad',
      'Guantes de Media Tensión',
      'Telurometro, medidor de resistencia de suelo',
      'Eslingas, arnés, guayas'
    ]
  }
];

const Servicios = () => {
  return (
    <section className="py-10 px-6 bg-white text-gray-800">
      <h2 className="text-3xl md:text-4xl font-bold text-[#003366] mb-10 text-center">Nuestros Servicios</h2>
      <div className="max-w-6xl mx-auto space-y-16">
        {servicios.map((servicio, index) => (
          <div key={index} className="grid md:grid-cols-2 gap-8 items-start">
            <div>
              <img src={servicio.imagen} alt={servicio.titulo} className="rounded-lg shadow-md w-full h-auto object-cover" />
            </div>
            <div>
              <h3 className="text-2xl font-semibold text-[#003366] mb-4">{servicio.titulo}</h3>
              <ul className="list-disc list-inside space-y-1">
                {servicio.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Servicios;
